module.exports = __webpack_public_path__ + "img/Nyromantikk_Tanker_i_tida_Hamsun.7f52704f.jpg";